module.exports = __webpack_public_path__ + "static/img/honour3.7769638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/honour3.png
// module id = 1VZc
// module chunks = 1